import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl, getAuthToken } from '../../../services/api';

const API_BASE = () => `${getApiBaseUrl()}/api/admin/resources`;

const AccessPermissionsTab = () => {
  const { t } = useTranslation('resourcesManagement');
  const [exams, setExams] = useState([]);
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;
    Promise.all([
      fetch(`${API_BASE()}/access`, { headers }).then((r) => r.json()),
      fetch(`${API_BASE()}/downloads?limit=100`, { headers }).then((r) => r.json()),
    ])
      .then(([accessRes, dlRes]) => {
        if (accessRes.success) setExams(accessRes.exams || []);
        if (dlRes.success) setDownloads(dlRes.downloads || []);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-message">Loading...</div>;
  return (
    <div className="tab-content">
      <p>{t('accessPermissions.freeVsLogin')}: PDFs are free; Word documents require login. This is enforced by the Exams API.</p>
      <h4 className="resources-section-title">{t('accessPermissions.downloadsTracking')}</h4>
      <div className="resources-table-wrap">
        <table className="resources-table">
          <thead>
            <tr>
              <th>User (email)</th>
              <th>Exam</th>
              <th>File type</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {downloads.map((d) => (
              <tr key={d.id}>
                <td>{d.email || 'Anonymous'}</td>
                <td>{d.exam_title}</td>
                <td>{d.file_type}</td>
                <td>{d.downloaded_at ? new Date(d.downloaded_at).toLocaleString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!downloads.length && <p style={{ padding: 16 }}>No downloads recorded yet.</p>}
      </div>
    </div>
  );
};

export default AccessPermissionsTab;
